import { useSnackbarStore } from '@components/shared/Snackbar/store';
import { theme } from '@config/theme';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { SnackbarContent } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';

export const NotificationSnackbar = () => {
	const { title, message, severity, isOpen, closeSnackbar } = useSnackbarStore();

	return (
		<Snackbar
			sx={{
				maxWidth: '480px',
			}}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={isOpen}
			onClose={closeSnackbar}
			autoHideDuration={3000}
		>
			<SnackbarContent
				sx={{
					background: '#FFF',
					borderRadius: '8px',
					boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.25)',
					padding: '20px',
					'& .MuiSnackbarContent-message': {
						padding: 0,
						width: '100%',
					},
				}}
				message={
					<div className="w-full">
						<div className="flex justify-between items-center">
							<div className="flex justify-center items-center">
								{severity === 'error' ? (
									<ErrorOutlineOutlinedIcon sx={{ color: theme.palette.custom.brightRed }} />
								) : (
									<CheckCircleOutlineOutlinedIcon sx={{ color: theme.palette.custom.teal }} />
								)}

								{severity === 'error' ? (
									<span className="text-error text-[16px] font-[700] ml-[8px]">{title}</span>
								) : (
									<span className="text-primary text-[16px] font-[700] ml-[8px]">{title}</span>
								)}
							</div>
							<IconButton size="small" aria-label="close" color="inherit" onClick={closeSnackbar}>
								<CloseIcon sx={{ color: '#7B809A', fontSize: '24px' }} fontSize="small" />
							</IconButton>
						</div>
						<div className="border-b border-[#E9ECEF] mt-[12px] mb-[14px]"></div>
						<div className="text-secondary text-[16px] font-[400]">{message}</div>
					</div>
				}
			/>
		</Snackbar>
	);
};
